import { gql } from "@apollo/client";

// Shared by CREATE_GROUP_ACTIVITY/UPDATE_GROUP_ACTIVITY so their return shape has one definition.
const GROUP_ACTIVITY_AUDIT_FIELDS = gql`
  fragment GroupActivityAuditFields on GroupActivity {
    uid
    createdBy
    organizationUid
    name
    day
  }
`;

const CREATE_GROUP_ACTIVITY = gql`
mutation CreateGroupActivity(
  $day: Day!, 
  $name: String!, 
  $startTime: Time!, 
  $endTime: Time!,
  $organizerUid: UUID,
  $placeUid: UUID,
  $groupUid: UUID!,
  $periodUid: UUID!) {
      createGroupActivity(
          input: {
              groupActivity: {
                  startTime: $startTime,
                  endTime: $endTime,
                  name: $name,
                  placeUid: $placeUid,
                  groupUid: $groupUid,
                  periodUid: $periodUid,
                  organizerUid: $organizerUid,
                  day: $day}
              }
      ){
          groupActivity {
              ...GroupActivityAuditFields
          }
      }
  }
  ${GROUP_ACTIVITY_AUDIT_FIELDS}`;

const UPDATE_GROUP_ACTIVITY = gql`mutation UpdateGroupActivity(
    $groupActivityUid: UUID!,
    $day: Day!,
    $name: String!,
    $startTime: Time!,
    $endTime: Time!,
    $organizerUid: UUID,
    $placeUid: UUID,
    $groupUid: UUID!,
    $periodUid: UUID!) {
    updateGroupActivityByUid(input: {
      groupActivityPatch: {
        startTime: $startTime,
        endTime: $endTime,
        name: $name,
        placeUid: $placeUid,
        periodUid: $periodUid,
        organizerUid: $organizerUid,
        groupUid: $groupUid,
        day: $day
      }, uid: $groupActivityUid
    }) {
      groupActivity {
        ...GroupActivityAuditFields
      }
    }
  }
  ${GROUP_ACTIVITY_AUDIT_FIELDS}`;

const LIST_GROUP_ACTIVITIES = gql`
query GetGroupActivities($first: Int = 100, $offset: Int = 0, $filter: GroupActivityFilter!) {
  allGroupActivities(
    filter: $filter,
    first: $first,
    offset: $offset,
    orderBy: [DAY_ASC, START_TIME_ASC, NAME_ASC]) {
    nodes {
      uid
      name
      day
      startTime
      placeUid
      endTime
      groupByGroupUid {
        uid
        name
        userGroupsByGroupUid{
          totalCount
        }
      }
      userByOrganizerUid {
        uid
        firstName
        lastName
      }
      periodByPeriodUid {
        uid
        name
      }
    }
    totalCount
  }
} `;

const DELETE_GROUP_ACTIVITY = gql`mutation DeleteGroupActivity($groupActivityUid: UUID!) {
  deleteGroupActivityByUid(input: {uid: $groupActivityUid}) {
    clientMutationId
  }
}
`;

const COPY_ALL_GROUP_ACTIVITIES = gql`mutation CopyAllGroupActivities($sourcePeriodUid: UUID!, $targetPeriodUid: UUID!) {
  copyAllGroupActivities(
    input: {sourcePeriodUid: $sourcePeriodUid, targetPeriodUid: $targetPeriodUid}
  ) {
    integer
  }
}
`;

const GET_ALL_APPOINTMENT_FOR_GROUP = gql`
mutation GetAllAppointementForGroup($groupUid: UUID!, $periodUid: UUID!) {
  getAllAppointementForGroup(
    input: { gUid: $groupUid, pUid: $periodUid }
  ) {
    appointments {
      endDate
      itemUid
      startDate
      title
      type
      place
      organizer
    }
  }
} `;

const GET_CONCURENT_ACTIVITY_FOR_GROUP_ACTIVITY = gql`mutation GetConcurentActivityForGroupActivity($groupActivityUid: UUID!) {
  getConcurentActivityForGroupActivity(input: {gaUid: $groupActivityUid}) {
    userActivities {
      userByUserUid {
        uid
        lastName
        firstName
      }
      activityByActivityUid {
        uid
        name
        startTime
        endTime
      }
    }
  }
}`;

export {
  CREATE_GROUP_ACTIVITY,
  UPDATE_GROUP_ACTIVITY,
  LIST_GROUP_ACTIVITIES,
  DELETE_GROUP_ACTIVITY,
  COPY_ALL_GROUP_ACTIVITIES,
  GET_ALL_APPOINTMENT_FOR_GROUP,
  GET_CONCURENT_ACTIVITY_FOR_GROUP_ACTIVITY,
};
